import { useMemo } from 'react'

import { PENGELOLAAN_KINERJA_PELAKSANAAN_STEPS } from 'app/KinerjaShared/constants/pelaksanaanSteps'
import { LangkahObservasiCard } from 'app/KinerjaPage/pages/PelaksanaanV2/components/LangkahObservasiCard'

import type { LangkahObservasiCardProps } from 'app/KinerjaPage/pages/PelaksanaanV2/components/LangkahObservasiCard'

export const LangkahLakukanTindakLanjutCard = (
  props: LangkahObservasiCardProps
) => {
  const CURRENT_STEP = 'DOCUMENT_FOLLOW_UP'
  const currentStateOrder =
    PENGELOLAAN_KINERJA_PELAKSANAAN_STEPS[props?.state]?.order ?? -1
  const stepOrder = PENGELOLAAN_KINERJA_PELAKSANAAN_STEPS[CURRENT_STEP].order

  const overrideState = useMemo(() => {
    if (currentStateOrder > stepOrder) return 'done'
    if (currentStateOrder === stepOrder) {
      if (props.latestFormState === 'SUBMITTED') return 'done'
      return 'unlocked'
    }
    return 'locked'
  }, [currentStateOrder, props, stepOrder])

  return <LangkahObservasiCard {...props} overrideState={overrideState} />
}
